"use client";

// The (codesmith) layout mounts the Codesmith shell, which owns this route's
// main pane (new-session view or session thread) and its <title>.
export default function SessionsPage() {
  return null;
}
